import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { dayLimitArrangementSchema } from '../schema';
import { DayLimitArrangementFormValues } from '../types';
import { DayLimitArrangementForEmployeeResponse } from 'generated';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

export const useCreateEditForm = (
  row?: DayLimitArrangementForEmployeeResponse | null
) => {
  const { t } = useTranslation('common');

  const defaultValues: DayLimitArrangementFormValues = row
    ? {
        id: row.id,
        validFrom: row.validFrom ? dayjs(row.validFrom).toDate() : null,
        validTo: row.validTo ? dayjs(row.validTo).toDate() : null,
        maxNumberOfDays: row.maxNumberOfDays,
        dayLimitArrangementNotApplicableForEmployee:
          row.dayLimitArrangementNotApplicableForEmployee ?? false,
        alternativePeriod: Boolean(row.alternativeTimeUnit),
        alternativeTimeUnit:
          row.alternativeTimeUnit === 'MONTH' ||
          row.alternativeTimeUnit === 'CUSTOM'
            ? row.alternativeTimeUnit
            : undefined,
        alternativeNrOfPeriods: row.alternativeNrOfPeriods,
        startDateForAlternativePeriod: row.startDateForAlternativePeriod
          ? dayjs(row.startDateForAlternativePeriod).toDate()
          : null
      }
    : {
        validFrom: null,
        validTo: null,
        maxNumberOfDays: undefined,
        dayLimitArrangementNotApplicableForEmployee: false,
        alternativePeriod: false,
        alternativeTimeUnit: undefined,
        alternativeNrOfPeriods: undefined,
        startDateForAlternativePeriod: null
      };

  return useForm<DayLimitArrangementFormValues>({
    resolver: yupResolver(dayLimitArrangementSchema(t)),
    defaultValues,
    mode: 'onChange'
  });
};

export default useCreateEditForm;
